import HomeTab from './HomeTab';
import Components from './components';

export default {
  HomeTab,
  Components,
};
